import React, { Component } from 'react';
import Button from 'devextreme-react/button';
import DataGrid, {
    Column,
    ColumnFixing,
    Editing,
    FilterRow,
    HeaderFilter,
    Paging,
    RemoteOperations,
    RequiredRule,
    Scrolling,
    Sorting
} from 'devextreme-react/data-grid';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import config from '../../common/config/config';
import { CustomRule } from 'devextreme-react/validator';
import { startSync } from '../../common/syncUtils';

const dataSource = AspNetData.createStore({
    key: 'id',
    loadUrl: `${config.apiUrl}/open-cases`,
    insertUrl: `${config.apiUrl}/open-cases`,
    updateUrl: `${config.apiUrl}/open-cases`,
    deleteUrl: `${config.apiUrl}/open-cases`
});

const endpoint = 'job/start/transactional/open-cases-import';

class OpenCasesComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 0,
            pageLimit: 10,
            totalRecords: 0,
            pageCount: 0,
            pageNeighbours: 2,
            showFilterRow: true,
            showHeaderFilter: true,
            currentFilter: 'auto',
            selectTextOnEditStart: true,
            startEditAction: 'click',
            errors: [],
            isAuthenticated: false,
            user: undefined,
            mode: 'nextColumn',
            readOnly: true,
            height: window.innerHeight - config.pxToSubtract
        };
    }

    handleSync = () => {
        try {
            startSync(endpoint);
        } catch (error) {
            console.error(error);
        }
    };

    render() {
        return (
            <div>
                <h1>Open Cases</h1>

                <div>
                    <ul style={{ listStyleType: 'none' }}>
                        {this.state.errors.map((value, index) => {
                            return <li style={{ color: 'red' }} key={index}>{value}</li>;
                        })}
                    </ul>
                </div>

                <div className="datagrid">
                    <Button text="Sync" onClick={this.handleSync} />

                    <DataGrid
                        id="gridContainer"
                        dataSource={dataSource}
                        showBorders={true}
                        keyExpr="id"
                        rowAlternationEnabled={true}
                        showRowLines={true}
                        allowColumnResizing={true}
                        columnResizingMode={'nextColumn'}
                        allowColumnReordering={true}
                        columnAutoWidth={true}
                        height={this.state.height}
                    >
                        <ColumnFixing enabled="true" />
                        <Sorting mode="multiple" />
                        <RemoteOperations paging={true} filtering={true} sorting={true} grouping={true} />
                        <Paging defaultPageSize={config.defaultPageSize} />
                        <Scrolling mode="virtual" rowRenderingMode="virtual" />

                        <Editing
                            mode="batch"
                            allowUpdating={!this.state.readOnly}
                            allowAdding={!this.state.readOnly}
                            allowDeleting={!this.state.readOnly}
                        />

                        <FilterRow
                            visible={this.state.showFilterRow}
                            applyFilter={this.state.currentFilter}
                            showAllText=""
                        />

                        <HeaderFilter visible={this.state.showHeaderFilter} />

                        <Column dataField="dataAsOf" dataType="date">
                            <RequiredRule message="Data as of is required" />
                        </Column>

                        <Column dataField="kvpsId">
                            <RequiredRule message="KVPS ID is required" />
                            <CustomRule
                                reevaluate={true}
                                validationCallback={this.kvpsIdValidator}
                                message="KVPS ID must match format DEU28100A"
                            />
                        </Column>

                        <Column dataField="vin">
                            <RequiredRule message="VIN is required" />
                        </Column>

                        <Column dataField="leadId">
                            <RequiredRule message="Lead ID is required" />
                        </Column>

                        <Column dataField="leadOrigin">
                            <RequiredRule message="Lead Origin is required" />
                        </Column>

                        <Column dataField="leadSubject">
                            <RequiredRule message="Lead Subject is required" />
                        </Column>

                        <Column dataField="leadStartDate" dataType="date">
                            <RequiredRule message="Lead Start Date is required" />
                        </Column>

                        <Column dataField="effectiveStartDate" dataType="date">
                            <RequiredRule message="Effective Start Date is required" />
                        </Column>

                        <Column dataField="effectiveEndDate" dataType="date">
                            <RequiredRule message="Effective End Date is required" />
                        </Column>

                        <Column dataField="remainingDays" dataType="number">
                            <RequiredRule message="Remaining Days is required" />
                            <CustomRule
                                reevaluate={true}
                                validationCallback={this.nonNegativeIntegerValidator}
                                message="Remaining Days must be a non-negative integer"
                            />
                        </Column>
                    </DataGrid>
                </div>
            </div>
        );
    }

    kvpsIdValidator = (data) => {
        if (data.value === undefined || data.value === null || data.value === '') {
            return false;
        }

        return /^[A-Z]{3}[0-9]{5}[A-Z]$/.test(data.value);
    };

    nonNegativeIntegerValidator = (data) => {
        if (data.value === undefined || data.value === null || data.value === '') {
            return false;
        }

        return Number.isInteger(data.value) && data.value >= 0;
    };

    componentDidMount() {
        fetch(`${config.authUrl}`)
            .then(response => {
                response.json()
                    .then(body => {
                        if (body['authenticated'] === false) {
                            this.setState({ isAuthenticated: false });
                            window.location.reload();
                        } else {
                            this.setState({
                                isAuthenticated: true,
                                readOnly: body.readOnly
                            });
                        }
                    });
            });

        window.addEventListener('resize', this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions.bind(this));
    }

    updateDimensions() {
        this.setState({ height: parseInt(window.innerHeight) - config.pxToSubtract });
    }
}

export default OpenCasesComponent;